import { useNavigate, useParams } from 'react-router-dom';

import { KanbanPageLayout } from '@common/components/KanbanPageLayout';
import { TablePageLayout } from '@common/components/TablePageLayout';
import { LeadsKanbanBoard } from '@features/leads/components/LeadsKanbanBoard';
import { LeadsTable } from '@features/leads/components/LeadsTable';
import { LeadsToolbar } from '@features/leads/components/LeadsToolbar';

function LeadsPage() {
	const navigate = useNavigate();
	const { servicesProviderId, tabId, viewType } = useParams<{
		servicesProviderId: string;
		tabId: string;
		viewType: 'table' | 'board';
	}>();

	const viewMode = viewType || 'table';

	const handleViewModeChange = (newViewMode: 'table' | 'board') => {
		navigate(`/${servicesProviderId}/leads/${tabId}/${newViewMode}`);
	};

	const aboveContent = (
		<LeadsToolbar viewMode={viewMode} onViewModeChange={handleViewModeChange} />
	);

	return viewMode === 'board' ? (
		<KanbanPageLayout
			title='Leads'
			aboveKanbanContent={aboveContent}
			kanbanContent={<LeadsKanbanBoard />}
		/>
	) : (
		<TablePageLayout
			title='Leads'
			aboveTableContent={aboveContent}
			tableContent={<LeadsTable />}
		/>
	);
}

export default LeadsPage;
